/* global axios */
import ApiClient from './ApiClient';

// Comunicados de rede (incidente REATIVO): a mensagem do operador que a IA usa
// quando um contato afetado escreve. Encerra sozinho (validade + quarentena de
// estabilidade) ou na mão. Ver .ai/massiva-comunicado-rede.md
class AiNetworkIncidentNotices extends ApiClient {
  constructor() {
    super('ai/network_incident_notices', { accountScoped: true });
  }

  // A conta vem por parâmetro (mesmo padrão do aiNetworkOutages): não depende
  // do path da rota estar montado quando o store dispara.
  scopedUrl(accountId) {
    return accountId
      ? `${this.apiVersion}/accounts/${accountId}/${this.resource}`
      : this.url;
  }

  // → { ativos: [notice], encerrados: [notice] }
  list(accountId) {
    return axios.get(this.scopedUrl(accountId));
  }

  register(accountId, payload) {
    return axios.post(this.scopedUrl(accountId), payload);
  }

  // A previsão muda no meio do reparo: só mensagem e validade (o escopo é
  // imutável — trocar quem ouve seria outro comunicado).
  edit(accountId, id, payload) {
    return axios.patch(`${this.scopedUrl(accountId)}/${id}`, payload);
  }

  // Encerramento MANUAL (o operador que falou com o técnico não espera a
  // quarentena de estabilidade).
  clear(accountId, id) {
    return axios.post(`${this.scopedUrl(accountId)}/${id}/clear`);
  }

  // Janela da quarentena (minutos de estabilidade até auto-encerrar) — da
  // CONTA: vale pra todos os comunicados, inclusive os já em contagem.
  updateConfig(accountId, payload) {
    return axios.patch(`${this.scopedUrl(accountId)}/config`, payload);
  }
}

export default new AiNetworkIncidentNotices();
